import React, { useState, useRef } from 'react';
import classnames from 'classnames';
import GeneralModal from '@gp/components/GeneralModal';
import { useMemoizedFn } from 'ahooks';
import ElevatorPitchImageUpload from '@gp/pages/Pipeline/ProjectDetails/GameDetail/components/ElevatorPitch/components/ElevatorPitchImageUpload';
import type { IMaterialVO } from '@gp/types/global';
import type { IMilestoneFinancialVO, IMilestoneFinancialForecastVO } from '@gp/types/milestones';
import type { IGRAction } from '@gp/pages/Pipeline/ProjectDetails/Milestone/types';
import './index.scss';
import '@gp/pages/Pipeline/ProjectDetails/Milestone/components/UpdateGRModal/index.scss';
import { useAutoSaveParams } from '@gp/hooks/useAutoSaveParams';

export interface IUpdateGRFormModel {
  gate_review: string;
  gate_review_decision: string;
  dev_cost_actual: string;
  budget_next_milestone: string;
  approved_budget_to_next: string;
  dev_cost: string;
  key_milestones_financial: IMilestoneFinancialVO[];
  key_milestones_financial_forecast: IMilestoneFinancialForecastVO[];
  key_feedback: string;
  action_items: IGRAction[];
  next_milestone_scope: string;
  material: IMaterialVO[];
}
export interface IUpdateGRModalInstance {
  init: (payload: Partial<IUpdateGRFormModel>, currentMilestoneDate?: string) => void;
}

const ElevatorPitchModal = (props: any) => {
  const {
    className,
    visible = false,
    onConfirm,
    onCancel,
    valueParams,
    setValueParams,
    pageKeyCur,
    initialParams,
  } = props;
  // ImagesUploader组件实例
  const uploaderInstance = useRef(null);
  const [isJustConfirm, setIsJustConfirm] = useState(false);

  const handleSubmitInPage = useMemoizedFn(() => {
    // if (valueParams?.introduction || (!valueParams?.cloudPath && !valueParams?.introduction)) {
    onConfirm?.({
      cloud_path: valueParams?.cloudPath,
      introduction: valueParams?.introduction,
    });
    onCancel?.(false);
    // } else {
    //   setIsJustConfirm(true);
    // }
  });

  const updateImgInfo = (payload: any) => {
    setIsJustConfirm(false);
    setValueParams({
      ...valueParams,
      cloudPath: payload.path,
      cover: payload.cover,
    });
  };

  // 每隔5秒自动保存
  useAutoSaveParams({
    pageKey: pageKeyCur,
    initialParams,
    saveParamsCur: valueParams,
    isBegin: visible,
    isChangeValue: true,
  });

  return (
    <GeneralModal
      className={classnames('dbg-elevator-pitch-modal', className)}
      title={'Elevator Pitch'}
      modalSize={'auto'}
      isFont14={true}
      visible={visible}
      onConfirm={handleSubmitInPage}
      onClose={onCancel}
      content={
        <div className="dbg-elevator-pitch-modal-content">
          <div className="dbg-game-pillar-modal-des">
            <p>{'Recommended ratio: 16:9 or 4:3.'}</p>
          </div>
          <ElevatorPitchImageUpload
            ref={uploaderInstance}
            onChangeImg={(payload: any) => {
              updateImgInfo(payload);
            }}
            valueParams={valueParams}
            setValueParams={setValueParams}
            isJustConfirm={isJustConfirm}
          />
        </div>
      }
    />
  );
};

export default ElevatorPitchModal;
